export const mapPermissions = (data) => {
    if (!data && data.length > 0) return;
    return data.map(p => ({
        id: p.Attribute,
        canView: p.v === "1",
        canEdit: p.e === "1",
        isAction: p.IsAction === "1"
    }));
};